"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated This belongs in fmko-ts-widgets, also it should be removed
 */
class DirectPanel {
    addAndReplaceElement(elementHolder, toReplace) {
        let parent = toReplace.parentElement;
        const insertedElement = elementHolder instanceof HTMLElement ? elementHolder : elementHolder.element;
        parent.replaceChild(insertedElement, toReplace);
    }
    addWrapper(widget) {
        // Intentionally left empty
    }
}
exports.default = DirectPanel;
//# sourceMappingURL=DirectPanel.js.map